import React from "react";
import { TimePicker } from "antd";
const format = "HH:mm";
const TimeDeparture = ({
  index,
  timeDeparture,

  changeTimeDepartureInput,
  setFieldValue,
}) => {
  return (
    <>
      <TimePicker
        className="form-control"
        style={{
          width: "98%",
          borderRadius: "4px",
        }}
        id={`flightLegs.onward[${index}]departureTime`}
        name={`flightLegs.onward[${index}]departureTime`}
        use24Hours
        value={timeDeparture && timeDeparture[index]?.time}
        onChange={(time, timeString) => {
          changeTimeDepartureInput(time, timeString, index);
          setFieldValue(`flightLegs.onward[${index}]departureTime`, timeString);
        }}
        required
        format={format}
      />
    </>
  );
};

export default TimeDeparture;
